import React from 'react';
import { useSelector } from 'react-redux';
import DbOrders from './dbComponents/dbOrders';
import TopProducts from './dbComponents/topProducts';
import TopSellers from './dbComponents/topSellers';
import Campaings from './dbComponents/campaings';
import CashFlow from './dbComponents/cashFlow';
import TotalSales from './dbComponents/totalSales';
import PurchaseOrders from './dbComponents/purchaseOrders';
import Inventory from './dbComponents/inventory';
import Clockin from './dbComponents/clockIn';
import IndependentRetailSolution from './dbComponents/IndependentRetailSolution';
import CustomerCare from './dbComponents/CustomerCare';
import SupportResource from './dbComponents/SupportResource';

const Dashboard = ({
  orders,
  campaings,
  cashdrawer,
  inventory,
  sales,
  timesheet,
  topProducts,
  topSellers,
  purchaseOrder,
  handleTopProductSalesFilter,
  handleTopSellersFilter,
  handleSalesFilter,
  handleInventoryFilter,
  isMedical
}) => {

  const { applicationSettings } = useSelector(state => state.common || {});
  const { isHighTide } = applicationSettings || {};

  return (
    <div className="dashboard p-0 m-0">
      <div className='row'>
        <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-0">
          <DbOrders orders={orders} />
          <TopSellers topSellers={topSellers} handleTopSellersFilter={handleTopSellersFilter} />
          <TopProducts topProducts={topProducts} handleTopProductSalesFilter={handleTopProductSalesFilter} />
          {isMedical && <PurchaseOrders purchaseOrder={purchaseOrder} />}
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
          <CashFlow cashdrawer={cashdrawer} />
          <div className="row ml-0 justify-content-between">
            <div className="col-lg-6 col-md-12 col-sm-12 pl-0 pr-0">
              <TotalSales sales={sales} handleSalesFilter={handleSalesFilter} />
              <Inventory inventory={inventory} handleInventoryFilter={handleInventoryFilter} />
              {isMedical && <Clockin timesheet={timesheet} />}
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 pr-0">
              {!isHighTide && <React.Fragment>
                  <CustomerCare />
                  <IndependentRetailSolution />
                </React.Fragment>}
              <SupportResource />
              {isMedical && <div style={{ marginTop: "20px" }}><Campaings campaings={campaings} /></div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;